import z from 'zod';
import { IFieldErrors, ValidationError } from 'src/types/validation';

const RoomSchema = z.object({
  roomType: z.string().min(1),
  maximumCapacity: z.number().nonnegative()
});

export interface IRoom {
  roomType: string;
  maximumCapacity: number;
}

//update: Partial<IRoom>
export const getSchema = () => {
  return RoomSchema;
};

export const validate = (update: Partial<IRoom>): IRoom => {
  const schema = getSchema();
  try {
    // Ensure there are changes from the original record
    const validated = schema.parse(update);
    return {
      ...validated
    };
  } catch (error: any) {
    if (error instanceof z.ZodError) {
      const errors: IFieldErrors = error.format();
      throw new ValidationError(errors);
    }
    throw new Error(error?.message || '');
  }
};